/**
 * Refund & Cancellation Policy — /refund-cancellation
 *
 * Adapted from Nikshala's standing refund policy for personalized services.
 * Applies specifically to Concierge (the only paid service on Ministry of
 * Exchange - Northstar/Cohort/Assembly/Drift/Smart Packing are all free).
 * Published as final on 2026-07-28 per founder decision.
 */
import { Link } from "react-router-dom";

export default function Refund() {
  return (
    <div className="min-h-screen bg-paper">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-12 sm:py-16" data-testid="refund-page">
        <div className="text-[10px] uppercase tracking-[0.2em] text-elec font-bold">Ministry of Exchange</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-bold tracking-tight text-ink">Refund &amp; Cancellation Policy</h1>
        <p className="mt-3 text-sm text-muted" data-testid="refund-last-updated">
          Last updated: 1 August 2026
        </p>

        <div className="mt-10 space-y-8 text-[15px] leading-relaxed text-ink/85 [&_h2]:mt-8 [&_h2]:mb-3 [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-ink [&_p]:mb-3 [&_ul]:mb-3 [&_ul]:ml-5 [&_ul]:list-disc [&_li]:mb-1">
          <p>
            This Refund and Cancellation Policy applies to <b>Concierge</b>, the only paid service on Ministry of Exchange.
            All other products (<Link to="/" className="text-elec font-semibold underline">Northstar, Cohort, Assembly, Drift, Smart Packing</Link>) are free.
          </p>

          <section>
            <h2>1. Refund Policy</h2>
            <p>
              Due to the personalized, time-intensive nature of Concierge's human-assisted visa support, our refund
              policy is:
            </p>
            <ul>
              <li><b>Full refund:</b> issued if we are unable to deliver the service due to circumstances on our end.</li>
              <li><b>Partial refund (up to 50%):</b> available if you cancel before we begin work on your case.</li>
              <li><b>No refund:</b> once work on your case has started. Concierge requires significant individual time and coordination from the outset, so please review the service scope carefully before booking.</li>
            </ul>
          </section>

          <section>
            <h2>2. Cancellation by You</h2>
            <p>
              You may cancel Concierge at any time by contacting us in writing at
              {" "}<a href="mailto:nd@nikshala.com" className="text-elec font-semibold underline">nd@nikshala.com</a>.
              We will process your cancellation request within 5-6 business days.
            </p>
          </section>

          <section>
            <h2>3. Cancellation by Us</h2>
            <p>
              We reserve the right to cancel your Concierge booking if: payment is not completed; you provide false or
              misleading information relevant to the service; you engage in illegal or unethical behavior. If we cancel
              your booking, we will provide a pro-rated refund for any unused portion of the service.
            </p>
          </section>

          <section>
            <h2>4. Contact</h2>
            <p>
              Questions about this policy:
              {" "}<a href="mailto:nd@nikshala.com" className="text-elec font-semibold underline">nd@nikshala.com</a>
              {" "}or <a href="tel:+918263907201" className="text-elec font-semibold underline">+91 82639 07201</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
